import { observer } from 'mobx-react';
import React, { useEffect, useMemo, useState } from 'react';
import { ComboItem } from '../../components/ComboItem/ComboItem';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { getTranslate } from 'src/utils/helpers';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import { IResponseComboItem } from '~/types/combo';
import { PRODUCT_TYPE } from '~/types/product';
import { productUtils } from '~/utils/productUtils';
import './style.scss';

const DealComboItemsBlock: React.FC = observer((): JSX.Element | null => {
  const [selectedItem, setSelectedItem] = useState<IResponseComboItem | undefined>(undefined);

  // select first item
  useEffect(() => {
    setSelectedItem(orderProductModalStore.product?.items?.[0]);
  }, []);

  const selectItemDescription = useMemo((): string | undefined => {
    if (!orderProductModalStore.product || !orderProductModalStore.product.items?.length) return undefined;

    const selectItem: IResponseComboItem | undefined = orderProductModalStore.product.items.find((item) => item.id === selectedItem?.id);
    if (!selectedItem) return undefined;

    const units = productUtils.getComboItemUnits(selectItem);
    const text: string = [...units, getTranslate(selectItem?.description)].filter(Boolean).join(' • ');

    return text;
  }, [selectedItem]);

  if (!orderProductModalStore.product?.items?.length) return null;

  return (
    <ScrollableBlock showScrollbar scrollbarSize="small" className="full-height mt-4 mb-4" scrollClassName="product-block d-flex flex-column px-6">
      <ScrollableBlock direction="horizontal" showScrollbar scrollbarSize="small" className="product-deal-combo-items-block__scroll">
        <ul className="d-flex flex-row gap-20">
          {orderProductModalStore.product.items.map((item, index) => (
            <ComboItem
              key={`${item.id}-${index}`}
              type={PRODUCT_TYPE.DEAL_COMBO}
              item={item}
              selected={selectedItem?.id === item.id}
              onSelectItem={setSelectedItem}
            />
          ))}
        </ul>
      </ScrollableBlock>

      <p className="family-regular color-dark text-size-14 letter-spacing-5 mt-4">{selectItemDescription}</p>
    </ScrollableBlock>
  );
});

export default DealComboItemsBlock;
